// renders dialog via JS
//
// Dialog.render({body: 'foo', title: 'Confirmation'})
// Dialog.close()

import BaseController from "./base_controller"

class DialogController extends BaseController {
  // pre-render side dilaog, so when we add "show" class, it slides in via css anaimation
  static prepare() {
    $(document.body).append(`
      <div id="modal-dialog">
        <div
          onclick="Dialog.close()"
          style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(111, 111, 111, 0.4);"
        ></div>

        <div class="modal fade" tabindex="-1" role="dialog" style="padding-right: 15px; display: block; z-index: 11;" aria-modal="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-primary modal-action" data-bs-dismiss="modal" onclick="Dialog.actionFunction()" style="display: none;"></button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onclick="Dialog.close(true)">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `)
  }

  static close(doConfirm) {
    if (doConfirm) {
      let text = Dialog.cancelConfim()
      if (text) {
        if (!confirm(text)) {
          return
        }
      }
    }

    Dialog.cancelConfim(null)

    let node = $('#modal-dialog')
    node.remove()
  }

  // base method that creates side dialog
  static render(opts = {}) {
    if (typeof opts != 'object') {
      opts = {body: opts}
    }

    this.close()
    this.prepare()

    if (opts.done) {
      this.actionFunction = () => {
        opts.done()
        Dialog.close()
      }
    } else {
      this.actionFunction = null
    }

    setTimeout(()=>{
      const node = $('#modal-dialog')
      node.find('.modal').addClass('show')
      node.find('.modal-title').html(opts.title || 'Confirmation')
      node.find('.modal-body').html(opts.body || 'No body given')

      if (opts.done) {
        node.find('.modal-action').show()
        node.find('.modal-action').html(opts.action || 'Confirm')
      }
    }, 50)

  }

  // load frame data via url
  static load(path, opts = {}) {
    Dialog.lastPath = path
    $.get(path, data => {
      opts.body = data
      this.render(opts)
    })
  }

  static isOpen() {
    return !!$('#side-dialog')[0]
  }

  static reload() {
    Dialog.load(Dialog.lastPath)
  }

  static cancelConfim(text) {
    if (text === undefined) {
      return Dialog.cancelConfimText
    } else {
      Dialog.cancelConfimText = text
    }
  }

  //

  close() {
    DialogController.close()
  }

  // if initialized via Stimulus controller, just get attrs and call base method
  connect() {
    const attrs = this.getAttributes()
    const html = this.element.innerHTML
    this.element.innerHTML = ''
    // DialogController.render({bodyhtml, attrs)
  }
}

// BaseController.register('side-dialog')

// allows -> Dialog.load(path)
window.Dialog = DialogController

